export const newsList = [
  {
    id: "n1",
    title: "2026 年度电影市场盘点：国产片票房再创新高",
    category: "国内资讯",
    summary:
      "截至目前，本年度国产影片累计票房已突破历史纪录，现实题材与科幻类型成为市场增长的双引擎，观众结构也呈现出新的变化。",
    content: [
      "随着年末档期的临近，本年度电影市场正式交出成绩单。据行业统计，国产影片累计票房已刷新历史纪录，其中现实题材与科幻类型贡献了超过一半的增量。",
      "值得注意的是，观众结构正在发生改变。数据显示，25 岁以下的年轻观众占比进一步提升，而家庭观影群体也在周末档期明显回升，带动了多类型影片的共同增长。",
      "业内分析认为，内容质量的整体提升是本轮增长的核心原因。多部影片在剧本打磨与类型创新上持续投入，逐步建立起稳定的口碑传播链条。",
      "展望明年，多部已定档的重点影片被寄予厚望，市场普遍预期总票房将保持温和增长态势。",
    ],
    source: "影视观察",
    publishedAt: "2026-10-15",
    cover:
      "https://readdy.ai/api/search-image?query=Cinema%20auditorium%20filled%20with%20a%20large%20attentive%20audience%2C%20warm%20projector%20light%20from%20the%20screen%2C%20deep%20navy%20seats%20with%20amber%20accents%2C%20elegant%20editorial%20mood%2C%20soft%20cinematic%20depth%2C%20high%20detail&width=800&height=500&seq=n1-cover-91aa&orientation=landscape",
  },
  {
    id: "n2",
    title: "国际电影节落幕 华语影片斩获三项大奖",
    category: "国际资讯",
    summary:
      "本届国际电影节正式闭幕，多部华语影片在竞赛单元表现亮眼，分别斩获最佳影片、最佳导演与最佳摄影三项重要奖项。",
    content: [
      "经过十天的展映与评审，本届国际电影节落下帷幕。华语影片在竞赛单元中表现突出，斩获三项重要奖项。",
      "评委会在颁奖词中表示，获奖作品以细腻的影像语言与克制的叙事节奏，呈现了普通人在时代变迁中的真实处境，具有跨文化的感染力。",
      "多位主创在采访中提到，海外影展的关注为他们带来了更多合作机会，也让更多国际观众开始关注华语电影的多元表达。",
      "据悉，获奖影片将于近期陆续在国内外院线及流媒体平台与观众见面。",
    ],
    source: "国际影讯",
    publishedAt: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=Glamorous%20international%20film%20festival%20red%20carpet%20at%20night%2C%20warm%20golden%20lights%20and%20deep%20navy%20sky%2C%20elegant%20crowd%20silhouettes%20blurred%2C%20festive%20premium%20mood%2C%20high%20detail&width=800&height=500&seq=n2-cover-91aa&orientation=landscape",
  },
  {
    id: "n3",
    title: "专访导演陈思远：科幻电影的本土化表达",
    category: "影人报道",
    summary:
      "在《星际迷航：黎明》广受好评之后，导演陈思远接受了我们的专访，聊了聊他如何把东方的情感内核放进宏大的科幻外壳里。",
    content: [
      "《星际迷航：黎明》上映后收获了大量讨论，而导演陈思远更愿意把它称为「一部关于回家的电影」。",
      "在采访中，他坦言创作初期最大的难题不是特效，而是如何让观众相信一个发生在深空里的故事与自己的生活有关。为此，他把大量笔墨放在人物的日常情感上。",
      "「科幻只是一个容器，真正打动人的永远是里面装的东西。」他说，团队花了近一年时间打磨剧本，直到每一个人物的动机都站得住脚。",
      "谈到未来计划，他表示会继续尝试不同类型，但「讲一个能让普通人共情的故事」始终是底线。",
    ],
    source: "影人访谈",
    publishedAt: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=Director%20sitting%20in%20a%20dim%20screening%20room%20during%20an%20interview%2C%20warm%20amber%20lamp%20light%20and%20deep%20navy%20shadows%2C%20thoughtful%20editorial%20portrait%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=500&seq=n3-cover-91aa&orientation=landscape",
  },
  {
    id: "n4",
    title: "流媒体平台竞争加剧 内容投入持续攀升",
    category: "行业观察",
    summary:
      "多家流媒体平台公布最新季度财报，内容采购与自制投入继续增长，而用户增长放缓也让行业开始重新思考内容策略。",
    content: [
      "最新公布的季度财报显示，主流流媒体平台的内容支出仍在持续攀升，自制剧集与独播内容的比重进一步提高。",
      "与此同时，用户增长明显放缓，行业从「跑马圈地」进入「精耕细作」阶段。如何在控制成本的同时保持内容质量，成为共同的课题。",
      "多家平台开始尝试更灵活的排播模式与区域化内容策略，以更低的成本触达更精准的受众。",
      "分析人士认为，未来一年将是行业格局重塑的关键期，内容与运营效率将共同决定平台的长期竞争力。",
    ],
    source: "行业观察",
    publishedAt: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20minimal%20streaming%20service%20interface%20on%20a%20large%20screen%2C%20deep%20navy%20background%20with%20warm%20amber%20accent%20tiles%2C%20clean%20high%20tech%20editorial%20mood%2C%20high%20detail&width=800&height=500&seq=n4-cover-91aa&orientation=landscape",
  },
  {
    id: "n5",
    title: "古装剧回暖 多部大制作扎堆定档",
    category: "国内资讯",
    summary:
      "进入第四季度，多部古装大制作陆续定档，题材从历史正剧到权谋群像一应俱全，市场对古装赛道的关注度明显回升。",
    content: [
      "沉寂一段时间后，古装剧在第四季度重新热闹起来，多部大制作陆续宣布定档。",
      "从已公布的片单来看，题材覆盖历史正剧、权谋群像与轻古装等多个方向，制作规格与服化道水准普遍提升。",
      "平台方表示，观众对古装剧的审美要求在不断提高，单纯依靠视觉奇观已难以留住用户，扎实的剧本与人物塑造才是关键。",
      "业内预计，本季古装剧的整体表现将为来年的题材布局提供重要参考。",
    ],
    source: "影视观察",
    publishedAt: "2026-10-10",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20set%20with%20elegant%20costumes%20and%20lanterns%2C%20warm%20amber%20light%20and%20deep%20crimson%20accents%2C%20refined%20editorial%20mood%2C%20soft%20cinematic%20depth%2C%20high%20detail&width=800&height=500&seq=n5-cover-91aa&orientation=landscape",
  },
  {
    id: "n6",
    title: "好莱坞编剧罢工后续 剧集制作周期普遍延长",
    category: "国际资讯",
    summary:
      "受此前行业罢工影响，多部备受期待的剧集宣布延期。制作方正在调整排播计划，观众的等待时间可能进一步拉长。",
    content: [
      "受此前编剧与演员工会行动的影响，好莱坞多部重点剧集的制作周期被普遍延长。",
      "多家制作公司近日更新了排播计划，部分原定于本季上线的剧集被推迟至明年，个别项目甚至需要重新开发剧本。",
      "业内人士分析，制作节奏的调整虽然短期内影响了内容供给，但也为剧本打磨留出了更多空间。",
      "对于观众而言，等待时间变长的同时，也有望看到完成度更高的作品。",
    ],
    source: "国际影讯",
    publishedAt: "2026-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20Hollywood%20film%20studio%20backlot%20at%20dusk%2C%20warm%20amber%20lights%20on%20quiet%20sound%20stages%2C%20deep%20navy%20sky%2C%20calm%20reflective%20mood%2C%20high%20detail%20cinematic&width=800&height=500&seq=n6-cover-91aa&orientation=landscape",
  },
  {
    id: "n7",
    title: "实力派演员林寒：从配角到影帝的十年",
    category: "影人报道",
    summary:
      "出道十年，从无人问津的龙套到备受认可的影帝，林寒在一次长谈中回顾了那些不被看见的日子，以及他对表演的理解。",
    content: [
      "在最新作品上映后，演员林寒的表演再次成为讨论焦点。对他而言，这已经是入行的第十年。",
      "「最开始那几年，我演过很多连名字都没有的角色。」他回忆道，正是那些日子让他学会了如何用最小的动作传递最多的信息。",
      "谈到方法，他表示自己更在意人物的「动机」而非「情绪」，因为只有理解了人物为什么这么做，表演才不会流于表面。",
      "对于未来，他依然保持着谨慎的期待：「我希望每一部作品，都能比上一部再真诚一点。」",
    ],
    source: "影人访谈",
    publishedAt: "2026-10-07",
    cover:
      "https://readdy.ai/api/search-image?query=Thoughtful%20male%20actor%20portrait%20backstage%20in%20warm%20amber%20light%2C%20deep%20navy%20shadows%2C%20quiet%20editorial%20mood%2C%20shallow%20depth%20of%20field%2C%20high%20detail&width=800&height=500&seq=n7-cover-91aa&orientation=landscape",
  },
  {
    id: "n8",
    title: "AI 技术进入影视制作 特效工业迎来变革",
    category: "行业观察",
    summary:
      "从概念设计到后期合成，人工智能正在越来越多地参与影视制作流程。效率提升的同时，行业也在讨论新技术带来的边界问题。",
    content: [
      "人工智能正在悄然改变影视制作的工作方式。从概念设计、分镜预演到后期合成，AI 工具已经进入多个环节。",
      "多位从业者表示，新技术显著缩短了前期筹备与部分特效环节的周期，让中小团队也有机会完成过去难以企及的视觉效果。",
      "不过，行业也在讨论随之而来的边界问题，包括版权归属、创作署名以及从业者的技能转型。",
      "多数受访者认为，AI 更像是一种新的工具，最终决定作品高度的仍然是人的审美与判断。",
    ],
    source: "行业观察",
    publishedAt: "2026-10-06",
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20visual%20effects%20workstation%20with%20glowing%20holographic%20scenes%2C%20deep%20navy%20blue%20with%20electric%20orange%20accents%2C%20clean%20high%20tech%20editorial%20mood%2C%20high%20detail&width=800&height=500&seq=n8-cover-91aa&orientation=landscape",
  },
  {
    id: "n9",
    title: "春节档前瞻：十余部重点影片集中上映",
    category: "国内资讯",
    summary:
      "随着春节档临近，目前已有十余部重点影片宣布定档。类型覆盖喜剧、科幻、动画与动作，竞争将异常激烈。",
    content: [
      "春节档历来是全年最重要的档期之一，今年同样不例外。截至目前，已有十余部重点影片宣布定档。",
      "从片单看，喜剧与动画依然是家庭观影的主力，而科幻与动作类型则瞄准了年轻观众，类型分布相对均衡。",
      "发行方普遍加大了宣发投入，多部影片提前开启了点映与路演，希望在开画前积累口碑。",
      "有分析认为，档期内的排片竞争将非常激烈，首日口碑很可能直接决定最终票房走向。",
    ],
    source: "影视观察",
    publishedAt: "2026-10-05",
    cover:
      "https://readdy.ai/api/search-image?query=Festive%20cinema%20marquee%20at%20night%20with%20warm%20golden%20lights%20and%20deep%20navy%20sky%2C%20crowd%20silhouettes%20entering%2C%20celebratory%20premium%20mood%2C%20high%20detail%20cinematic&width=800&height=500&seq=n9-cover-91aa&orientation=landscape",
  },
  {
    id: "n10",
    title: "亚洲剧集海外热度攀升 出海成新趋势",
    category: "国际资讯",
    summary:
      "越来越多亚洲剧集通过流媒体平台走向海外市场，悬疑与都市情感题材尤其受欢迎，出海正在成为行业新的增长点。",
    content: [
      "亚洲剧集正在海外市场获得越来越多关注。多个流媒体平台的数据显示，亚洲内容的播放量持续上升。",
      "其中，悬疑与都市情感题材最受欢迎，紧凑的叙事节奏与贴近生活的情感表达，成为吸引海外观众的关键。",
      "为适应不同市场，制作方开始在剧本阶段就考虑多语言配音与本地化宣发，出海逐渐从「事后发行」转向「前置规划」。",
      "业内人士认为，随着平台全球化布局的深入，亚洲剧集有望在更多地区形成稳定的受众群。",
    ],
    source: "国际影讯",
    publishedAt: "2026-10-04",
    cover:
      "https://readdy.ai/api/search-image?query=Global%20map%20of%20glowing%20connection%20lines%20over%20a%20deep%20navy%20world%2C%20warm%20amber%20nodes%2C%20clean%20high%20tech%20editorial%20mood%2C%20high%20detail%20digital%20art&width=800&height=500&seq=n10-cover-91aa&orientation=landscape",
  },
];